export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_SORTED = 'SET_SORTED';
export const SET_COLUMNS = 'SET_COLUMNS';
export const SET_EDITED_ROW = 'SET_EDITED_ROW';